/**
 * Shared constants for viewport and positioning utilities
 */

// Measured from actual rendered nodes - most task nodes are around 280-300px wide
// and 140-160px tall depending on content
export const NODE_WIDTH = 290;
export const NODE_HEIGHT = 150;
export const SPACING_PADDING = 30; // Space between nodes for overlap check
export const LAYOUT_PADDING = 40; // Starting position for first node
export const HORIZONTAL_GAP = 60; // Gap when placing to the right
export const VERTICAL_GAP = 50; // Gap when placing below
export const ZONE_PADDING = 50; // Padding around campaign zones
export const INTER_CAMPAIGN_GAP = 30; // Gap between campaign zones
